import { render, staticRenderFns } from "./ClientBalance.vue?vue&type=template&id=798e00b3&"
import script from "./ClientBalance.vue?vue&type=script&lang=js&"
export * from "./ClientBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports